export default {
  YourPassword: 'Your password has been changed.',
  CanBeUsed: 'You can now use it to sign into your account.',
  Connect: 'Sign in',
  notFound: 'Not Found',
};
